import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

import { emailAutomationApi } from '../api';
import { createErrorToast, createSuccessToast } from '../redux/modules/app';

import companyKeys from './models/company/keys';
import { camelCaseApiResponse, getPageData } from './util';

/* QUERIES
========================================================= */
// export const useCompanyPermissions = (companyId, options = {}) => useQuery(
//   companyKeys.companyPermissions(companyId),
//   () => camelCaseApiResponse(() => companyApi.getCompanyPermissions(companyId)),
//   options
// );
//
// export const useCompanyRequirementTemplateFolders = ({
//   companyId,
//   pageSize = 25,
//   options = {}
// }) => useInfiniteQuery(
//   companyKeys.companyRequirementTemplateFolders(companyId),
//   ({ pageParam = 1 }) => camelCaseApiResponse(() => companyApi.listRequirementTemplateFolders(
//     companyId,
//     { page: pageParam, pageSize }
//   )),
//   {
//     ...options,
//     getNextPageParam: getPageData
//   }
// );

/* MUTATIONS
========================================================= */

export const useSendEmailAutomationStepReport = ({
  stepId,
  options = {}
}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return useMutation(
    ({ email }) => camelCaseApiResponse(() => emailAutomationApi.sendEmailAutomationStepReport(stepId, email, userTimeZone)),
    {
      onMutate: async () => {
        dispatch(createSuccessToast({ title: 'Initiated Export' }));
      },
      onError: async error => {
        dispatch(createErrorToast({
          title: 'Oops! Something went wrong...',
          description: 'Your export was not initiated successfully.',
          error
        }));
      },
      onSuccess: async () => {},
      ...options
    }
  );
};
